import { SettingsOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { InitFailed } from 'src/basic-components/init-failed';
import { Loading } from 'src/basic-components/loading';
import { Rows } from 'src/basic-components/table/rows';
import T from 'src/basic-components/text';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import Page from 'src/components/Page';
import { useApi } from 'src/contexts/api-provider';
import { useNotify } from 'src/hooks/use-notify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { ManageUserBankAccountModal } from './manage-user-bank-account-modal';

export const ManageUserBankAccountsApp = () => {
  const [model, setModel] = useState();
  const [selectedRow, setSelectedRow] = useState();

  const params = useParams();
  const userId = params.userId;

  const { CoreApi } = useApi();
  const apiName = 'bankAccountsApi';
  const { t } = useTranslation();
  const notify = useNotify();

  const api = {
    initByAdmin: CoreApi(apiName, 'initByAdmin'),
    saveByAdmin: CoreApi(apiName, 'saveByAdmin'),
    deleteByAdmin: CoreApi(apiName, 'deleteByAdmin'),
  };

  useEffect(() => {
    if (model) return;
    api.initByAdmin(userId).then(setModel).catch(setModel);
  }, [model]);

  const columns = [
    { accessorKey: 'bankTitle', header: <T>bank-title</T> },
    { accessorKey: 'ownerName', header: <T>owner-name</T> },
    { accessorKey: 'cardNumber', header: <T>card-number</T> },
    { accessorKey: 'shebaNo', header: <T>sheba-number</T> },
    {
      accessorKey: 'id',
      header: '',
      cell: ({ row }) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => setSelectedRow(row.original)}
          endIcon={<SettingsOutlined />}
        >
          <T>manage</T>
        </Button>
      ),
    },
  ];

  if (!model) return <Loading />;
  if (model instanceof Error) return <InitFailed ex={model} onRetry={() => setModel(null)} />;

  return (
    <Page
      backUrl={PATH_DASHBOARD.user.manage}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: 'dashboard', href: PATH_DASHBOARD.root },
            { name: 'manage-users', href: PATH_DASHBOARD.user.manage },
            { name: 'manage-users-bank-accounts', href: '#' },
          ]}
        />
      }
      Control={
        <Button
          size="small"
          variant="outlined"
          onClick={() => setSelectedRow({ userId })}
          startIcon={<Iconify icon="line-md:list-3" />}
        >
          <T>add</T>
        </Button>
      }
    >
      <Rows columns={columns} data={model.bankAccounts} />
      <ManageUserBankAccountModal
        open={selectedRow != null}
        data={{ userId, ...selectedRow, banks: model.banks }}
        onClose={(bankAccount) => {
          if (!bankAccount) return setSelectedRow(null);

          if (selectedRow.id)
            setModel({
              ...model,
              bankAccounts: model.bankAccounts.map((x) => (x.id === bankAccount.id ? bankAccount : x)),
            });
          else setModel({ ...model, bankAccounts: [...model.bankAccounts, bankAccount] });

          setSelectedRow(null);
        }}
      />
    </Page>
  );
};
